module.exports = __webpack_public_path__ + "static/img/freezer_leisure.fce6875.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_leisure.jpg
// module id = 4/cj
// module chunks = 1